import styled from "styled-components";

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${({ color }) => color};
  margin: 0;
  box-sizing: border-box;
`;
